class TableCfg {
    constructor() {
        this.ascending = { value: false };
        this.buttonsData = {};
        this.columnDefinitions = [];
        this.columnList = [];
        this.defaultSortField = '';
        this.filterUrl = [];
        this.loadCount = 0;
        this.showFilter = false;
        this.showOrder = false;
        this.tableId = '';
        this.url = null;
        this.isAllSolutions =false;
    }
}

export default TableCfg;